(function () {
    'use strict';

    angular
        .module('app.completionTypes')
        .controller('CompletionTypesListController', CompletionTypesListController);

    CompletionTypesListController.$inject = ['common', 'dataservice', 'bootstrap.dialog', 'config'];
    /* @ngInject */
    function CompletionTypesListController(common, dataservice, bsDialog, config) {
        var vm = this;

        vm.title = 'Completion Types';
        vm.displayedItems = [];
        vm.items = [];
        vm.counts = [];
        vm.refresh = refresh;
        vm.entriesForLogType = entriesForCompletionType;
        vm.iconClassName = iconClassName;
        vm.showForServices = false;

        activate();

        function activate() {
            vm.showForServices = common.userService.isEmsApiType();
            var promises = [common.checkIsAdmin() , getItems(), getCounts()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function iconClassName(icon) {
            var parts = icon.split('glyphicon-');
            if (parts.length == 1) {
                parts = icon.split('fa-');
            }
            if (parts.length == 2) {
                return parts[1];
            }
            return "";
        }

        function entriesForCompletionType(completionTypeId) {
            for (var i = 0; i < vm.counts.length; i++) {
                if (vm.counts[i].Name == completionTypeId) {
                    return vm.counts[i].ActiveCount;
                }
            }
        }

        function getCounts() {
            return dataservice.getItems('api/CompletionTypes/CountsOfEntries/-1').then(function (response) {
                vm.counts = response.data;
                return vm.counts;
            }, function (error) { });
        }

        function getItems() {
            return dataservice.getItems('api/CompletionTypes').then(function (response) {
                vm.items = response.data;
                
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }

        function refresh() {
            getItems();
        }
    }
})();
